/* eslint-disable */
import { ajax } from "noquery-ajax";
import { httpsLogger } from "../p1s7/p1s7e1";
import { create } from "lodash";

interface Arguments {
  recycler_uid: string;
  recycler_location_uid: string;
}

function createConnectAccount({
  recycler_uid,
  recycler_location_uid,
}: Arguments) {
  return new Promise(function (resolve, reject) {
    let params = {
      firebase_uid: window.G_firebase_auth.IV_uid,
      firebase_token: window.G_firebase_auth.IV_id_token,
      recycler_uid: recycler_uid,
      recycler_location_uid: recycler_location_uid,
    };

    ajax({
      url: window.G_cloud_functions_base_url + "p1s7e7CreateConnectAccount",
      headers: {
        Accept: "application/json",
      },
      method: "POST",
      dataType: "json",
      data: params,
      success: function (result) {
        let response_data = {
          success: true,
          response: result,
          request_params: params
        }
        resolve(response_data);
      },
      error: function (error) {
        let error_data = {
          success: false,
          request_object: error,
          request_params: params,
          file_name: "p1s7e7.ts",
          class_name: "p1s7e7",
          method_name: "createConnectAccount",
          error_title: "Failed to create connect account.",
          error_description: "The server responded with an error when requesting to create a connect account.",
        };

        httpsLogger(error_data);
        reject(error_data);
      },
    });
  });
}

export default createConnectAccount;
